var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicChatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.51 12.068a2.893 2.893 0 01-2.126-.875 2.893 2.893 0 01-.875-2.125v-6c0-.833.292-1.541.875-2.125A2.893 2.893 0 017.51.068c.834 0 1.542.292 2.125.875.584.584.875 1.292.875 2.125v6c0 .834-.291 1.542-.875 2.125a2.893 2.893 0 01-2.125.875zm-1 7v-3.075c-1.734-.233-3.167-1.008-4.3-2.325-1.134-1.316-1.7-2.85-1.7-4.6h2c0 1.384.487 2.563 1.462 3.538.975.975 2.154 1.462 3.537 1.462 1.384 0 2.563-.487 3.538-1.462.975-.975 1.462-2.154 1.462-3.538h2c0 1.75-.566 3.284-1.7 4.6-1.133 1.317-2.566 2.092-4.3 2.325v3.075h-2zm1-9c.283 0 .52-.095.712-.287a.968.968 0 00.287-.713v-6a.968.968 0 00-.287-.712.968.968 0 00-.713-.288.968.968 0 00-.712.288.968.968 0 00-.288.712v6c0 .284.096.521.288.713a.964.964 0 00.712.287z",
    fill: "#9390A0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicChatIcon);
export default __webpack_public_path__ + "static/media/mic-chat-icon.267dcaf6ffd2d91c4a0359deb970d034.svg";
export { ForwardRef as ReactComponent };